import React from "react";
import FAQs from "../../utilities/components/FAQs";
import ContactInfo from "../../utilities/components/ContactInfo";
import BookingWizard from "./wizard/BookingWizard";

/**
 * The page to book an appointment or make a reservation.
 * @returns  The page to book an appointment or make a reservation.
 */
const BookingPage = () => {
  return (
    <div className="bg-slate-50 dark:bg-slate-950 min-h-screen transition-colors duration-300">
      <div>
        <section>
          <div
            style={{
              backgroundImage: "url('/assets/images/booking_cover.png')",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              height: "40vh",
            }}
            className="hidden w-screen pt-2 pb-2 md:block relative"
          >
            <div className="absolute inset-0 bg-black/40 dark:bg-black/60 flex items-center justify-center">
              <h1 className="text-4xl cmd:text-6xl text-white font-serif tracking-widest text-center px-4">
                Book Your Experience
              </h1>
            </div>
          </div>
        </section>

        <section className="relative -mt-20 z-10 px-4 pb-20 pt-32 md:pt-0">
          <BookingWizard />

          {/* Optional: Keep Contact/FAQs below if users get stuck, but styled nicely */}
          <div className="max-w-6xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white dark:bg-slate-900 p-8 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 h-full">
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">
                Need Help?
              </h3>
              <ContactInfo columnLayout={true} />
            </div>
            <div className="bg-white dark:bg-slate-900 p-8 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 h-full">
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">
                Frequently Asked Questions
              </h3>
              <FAQs columnLayout={true} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BookingPage;
